// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"styles_ellipsis__2bXTM","ellipsis1":"styles_ellipsis1__EXVEP","ellipsis2":"styles_ellipsis2__3K1Cd","ellipsis3":"styles_ellipsis3__3w_6v"};